import { AuthStateType } from "./interface";

export const state: AuthStateType = {
  isLoggedIn: false,
  view: null
};
